import { FC, useEffect } from "react";
import { Stack } from "@mui/material";
import { ColumnsInnerHeaderComponent } from "../../../../common/ag-grid/components/ColumnsInnerHeaderComponent";
import { useTotalInHeaderCalculator } from "../../../../common/ag-grid/utils/hooks/useTotalInHeaderCalculator.hook";
import type { CustomHeaderProps } from "ag-grid-react";
import { money } from "@/utils/numeral/money";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { Task } from "@/services/cloudchipr.api";
import { setTaskManagementViewDetails } from "@/store/task-management/taskManagementSlice";
import { useAppDispatch } from "@/store/hooks";

export const ForecastedEOMInnerHeader: FC<CustomHeaderProps> = (props) => {
  const dispatch = useAppDispatch();

  const total = useTotalInHeaderCalculator<Task>(
    props.api,
    (data) => data?.target?.forecasted_end_of_month,
    "sum",
  );
  const formatedMoney = money(total);

  let totalRows = 0;

  props.api.forEachNodeAfterFilterAndSort((node) => {
    if (node.group) {
      return;
    }

    totalRows++;
  });

  useEffect(() => {
    dispatch(
      setTaskManagementViewDetails({
        itemsCount: totalRows,
        totalCost: total,
      }),
    );
  }, [dispatch, totalRows, total]);

  return (
    <Stack position="relative">
      <ColumnsInnerHeaderComponent {...props} />

      <TypographyWithTooltip
        title={formatedMoney !== "N/A" ? `~${formatedMoney}` : formatedMoney}
        variant="caption"
      />
    </Stack>
  );
};
